import {
  useNavigate,
  useParams,
  useLocation,
  generatePath,
} from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { SecurityLockForm } from '@ui/src';
import { clearLockPanelState } from '../../store/slices/security';
import {
  schema,
  columns,
  columnsLabels,
  filtersSchema,
} from '../variables/lock-item-logs';
import useLockForm from '../hooks/use-lock-form';

import ROUTES from '../../../../routes';

const IndividualCustomerSecurityLockForm = ({
  type,
}: {
  type: 'locks' | 'logs' | 'devices';
}) => {
  const navigate = useNavigate();

  const { customerId } = useParams();
  const { search } = useLocation();
  const dispatch = useAppDispatch();

  const { activePermissions } = useAppSelector((state) => state.root);
  const { baseInformation } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );
  const {
    lockItem,
    locksTakeCount,
    lockItemAuditLogs,
    lockItemAuditLogsPagination,
  } = useAppSelector((state) => state.individualCustomers.info.security);

  const {
    getLockItem,
    getLocks,
    create,
    update,
    isSuccess,
    isLoading,
    isFetching,
    requestInProgress,
    updateInProgress,
    getList,
    lockItemLogsIsLoading,
    lockItemLogsIsFetching,
  } = useLockForm({
    userId: baseInformation?.userId,
  });

  return (
    <SecurityLockForm
      getLockItem={getLockItem}
      getLocks={getLocks}
      create={create}
      update={update}
      lockItem={lockItem}
      takeCount={locksTakeCount}
      activePermissions={activePermissions}
      clearLockPanelState={() => dispatch(clearLockPanelState())}
      onClose={() => {
        let link = '';

        if (type === 'locks') {
          link = generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS, {
            customerId: customerId as string,
          });
        } else if (type === 'logs') {
          link = generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS, {
            customerId: customerId as string,
          });
        } else if (type === 'devices') {
          link = generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES, {
            customerId: customerId as string,
          });
        }

        navigate(`${link}${search || ''}`);
      }}
      isSuccess={isSuccess}
      isLoading={isLoading}
      isFetching={isFetching}
      requestInProgress={requestInProgress}
      updateInProgress={updateInProgress}
      userId={baseInformation?.userId}
      lockItemAuditLogsPagination={lockItemAuditLogsPagination}
      lockItemAuditLogs={lockItemAuditLogs}
      getLockItemLogsList={getList}
      lockItemLogsSchema={schema}
      lockItemLogsFiltersSchema={filtersSchema}
      lockItemLogsColumns={columns}
      lockItemLogsColumnsLabels={columnsLabels}
      lockItemLogsIsLoading={lockItemLogsIsLoading}
      lockItemLogsIsFetching={lockItemLogsIsFetching}
      withoutUserSelector
    />
  );
};

export default IndividualCustomerSecurityLockForm;
